<div class="d-flex flex-column gap-3 my-auto w-100">
    <nav-item
        [hideChevronRight]="true"
        label="Catalog">
        <svg-icon key="catalog" fontSize="1.5rem"></svg-icon>
    </nav-item>

    <div class="h-line mx-auto"></div>

    @for (item of data().items(); track $index) {
         <presenter [data]="item" [allowFallback]="true" stop-click-bubble (click)="data().toggleSubMenu(item)"></presenter>
    }
</div>
